import React, {useContext} from 'react';
import {IDocumentCard} from "./types/document-card.types";
import DocumentCardView from "./document-card.view";
import {deleteDocument, deletePolicy, publishPolicy} from "./action/document-card.actions";
import {message} from "antd";
import UserLoginContext from "../../../context/userLoginContext";
import server from "../../../server";
import "../../../styles/component/document-card.scss";

const DocumentCard: React.FC<IDocumentCard> = (props) => {

    const {user} = useContext(UserLoginContext);

    async function handleDelete(id: string) {
        if (props.file.type === 'POLICY') {
            await deletePolicy(id);
        } else {
            await deleteDocument(id);
        }
        props.handleDeleteDoc(id);
    }

    async function handleUnpublishPolicy(
        id: string,
        status: string,
        reason: string
    ) {
        if (props.handleUnpublishPolicy) {
            await props.handleUnpublishPolicy(id, status, reason);
        }
    }

    const handleDownload = async () => {
        try {
            if (props.file.id) {
                const response = await server.document.download(props.file.orgDocumentId);
                if (response instanceof Blob) {
                    const url = URL.createObjectURL(response);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = props.file.name;
                    link.click();
                    // We immediately revoke the url as browser copies the url after then we do not need url
                    URL.revokeObjectURL(url);
                } else {
                    message.error("Unable to download policy");
                }
            } else {
                message.error("Failed to download policy!");
            }
        } catch (e) {
            console.error("Download error", e);
            message.error("Failed to download policy");
        }
    };

    return (

        <DocumentCardView
            isAdmin={user.isAdmin}
            file={props.file}
            handleDelete={handleDelete}
            handleDownload={handleDownload}
            showDelete={props.showDelete}
            showUnpublished={props.showUnpublished}
            showNotify={props.showNotify}
            showPublished={props.showPublished}
            handleUnpublishPolicy={handleUnpublishPolicy}
            handlePublishPolicy={props.handlePublishPolicy}
            handleNotifyPolicy={props.handleNotifyPolicy}
        />

    )


}
export default DocumentCard;
